//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import EmptyTip from '@/components/views/empty_tip'
import CommonImg from '@/components/views/common_img'
import CommonTabs from '@/components/views/common_tabs'
import LayoutTip from '@/views/building/_components/_layout_tip'

import detailSubPage from '@/common/mixins/detailSubPage'

import Service from '@/service/building'
import CommonService from '@/service'

import AudioAnalysis from '../img_preview/_audio_analysis'
import Countdown from '../img_preview/countdown'
import VrTip from '../img_preview/_vr_tip'
import audio from '../img_preview/mixin/audio'
import LayoutItem from '../img_preview/_layout_item'
import CommonFooter from '../_components/_common_footer'
import Consultants from '@/components/business/_excellent_consultants'

import vr_tip from '../img_preview/mixin/vr_tip'
import get_vr_msg from '../mixins/get_vr_msg'

export default {
    mixins: [
        detailSubPage,
        vr_tip,
        audio,
        get_vr_msg
    ],
    name: 'HOUSE_VR_PREVIEW',
    data () {
        return {
            loading: true,
            urls: [],
            tabs: [],
            type: '',
            building_id: '',
            title: '',
            excellent_consultants: [],
            building: {}
        }
    },
    computed: {
        show_empty () {
            return !this.loading && !this.urls.length
        },
        show_disclaimer () {
            return this.building.activities && this.building.activities.indexOf('vr_disclaimer') > -1
        }
    },
    mounted () {
        const { building_id, title, type, house_id } = this.$route.query
        this.building_id = building_id
        this.title = title
        this.type = type
        this.getData()
    },
    onShareAppMessage () {
        const { building_id } = this.$route.query
        const { title } = this
        return this.getShareInfo({
            title: `【${title}】的VR全景图在此，点击查看~`,
            path: this.getSharePath(`/building/vr?title=${title}&building_id=${building_id || ''}`)
        })
    },
    methods: {
        getData () {
            const { id, building_id, house_id } = this.$route.query
            CommonService.getBuilding(building_id, house_id).then((data) => {
                this.building = data
            })
            this.getVr().then(res => {
                this.urls = res.items
                this.loading = false
                this.getConsultants(res.building.id)
            })
        },
        preview (index) {
            this.$wx.previewImage({
                current: this.urls[index].orginal_url,
                urls: this.urls.map(({ orginal_url }) => orginal_url)
            })
        },
        getConsultants (id) {
            Service.excellentConsultants(id).then((data) => {
                this.excellent_consultants = data.slice(0, 3)
            })
        },
        goConsultants () {
            const { id, name } = this.building
            this.$router.push({
                path:`/consultants/filter/main?id=${id}&name=${name}&from=VR`
            })
        },
        goVideo (src) {
            const { id, name } = this.building
            this.$router.push({
                path: `/building/video?building_id=${id}&title=${name}&src=${src}`
            })
        }
    },
    components: {
        VrTip,
        LayoutTip,
        EmptyTip,
        CommonImg,
        CommonTabs,
        AudioAnalysis,
        CommonFooter,
        Consultants,
        LayoutItem
    }
}
